import React, { useEffect, useState, useContext, useCallback } from 'react';
import OffCanvas, { OffCanvasBody, OffCanvasHeader } from '../../../components/bootstrap/OffCanvas';
import Chat, { ChatGroup, ChatHeader } from '../../../components/Chat';
import InputGroup from '../../../components/bootstrap/forms/InputGroup';
import Textarea from '../../../components/bootstrap/forms/Textarea';
import Button from '../../../components/bootstrap/Button';
import Avatar from '../../../components/Avatar';
import Modal from '../../../components/bootstrap/Modal';

import showNotification from '../../../components/extras/showNotification';
import AuthContext from '../../../contexts/authContext';
import { updateProfile, signOut, getAuth } from 'firebase/auth';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import { useNavigate } from 'react-router-dom';

import { db, authService } from '../../../Firebase';
import { collection, doc, getDoc } from 'firebase/firestore';

const CommonHeaderChat = () => {
	const [state, setState] = useState<boolean>(false);
	const [modal, setModal] = useState<boolean>(false);

	const { userData, setUser } = useContext(AuthContext);
	const navigate = useNavigate();

	const handleOnClick = useCallback(() => navigate('/'), [navigate]);

	const logout = async () => {
		if (setUser) {
			setUser(null);
		}
		signOut(authService);
		handleOnClick();
	};

	useEffect(() => {
		const getUserName = async () => {
			const displayName = authService.currentUser?.displayName;

			if (!displayName) {
				const userUid = authService.currentUser?.uid;
				if (userUid) {
					const docRef = doc(db, 'users', userUid);
					const docData = await getDoc(docRef);

					if (docData) {
						const gettedData = docData.data();
						if (gettedData) {
							if (authService.currentUser !== null) {
								await updateProfile(authService.currentUser, {
									displayName: gettedData.name + ' 선생님',
								});
							}
						}
					}
				}
			}
		};
		getUserName();
	}, []);

	return (
		<>
			<div className='col d-flex align-items-center cursor-pointer' role='presentation'>
				<Dropdown setIsOpen={function noRefCheck() {}}>
					{/* <Button className='none' isLight={true} isOutline={false}>
							<div className='me-3'>
								
							</div>
						</Button> */}
					<DropdownToggle>
						<div className='me-3'>
							<div className='text-end'>
								<div className='fw-bold fs-6 mb-0'>{`${authService.currentUser?.displayName}`}</div>
							</div>
						</div>
					</DropdownToggle>
					<DropdownMenu>
						<DropdownItem>
							<Button onClick={logout}>로그아웃</Button>
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>
			</div>
		</>
	);
};

export default CommonHeaderChat;
